module.exports = __webpack_public_path__ + "static/media/颂BU1420-石材壁板开门方向.d84917c2.pdf";